import initMenu from "./main-menu";
import animationsV2 from "./animationsv2";
import initPageHeaderResize from "./page-header-resize";
import initSliders from "./sliders";

function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  initMenu();
  animationsV2();
  initPageHeaderResize();
  initSliders();
});

// Menu Active State (highlight current page link)
let current = window.location.pathname
  .replace(/index\.html?$/, "")
  .replace(/\/$/, "");

document.querySelectorAll(".main-menu li").forEach((li) => {
  const link = li.querySelector("a");
  if (!link) return;

  let href = new URL(link.getAttribute("href"), window.location.origin).pathname
    .replace(/index\.html?$/, "")
    .replace(/\/$/, "");

  // highlight only if exact match
  if (href === current) {
    li.classList.add("current-menu-item");
  } else {
    li.classList.remove("current-menu-item");
  }
});
